module.exports = __webpack_public_path__ + "img/whathot_bg_dots_lightblue.374b9c75.png";